<div class="commentary">
   <div>
       <i class="icofont-volume-bar"></i>
       <marquee>{{navMarquee}}</marquee>
   </div>
</div>